import React, { Component } from 'react';
import { SofaPanel, SofaCheckbox } from '@sofology/sofologycomponents';
import { appConfig } from 'configurations';

import './SofashieldPolicy.scss';

import { scrollHelper } from 'helpers';
import { Validatable, Scrollable } from 'interfaces';

const SOFOLOGY_POLICY_PATH = 'https://images.sofology.co.uk/image/upload/v1616692515/ipid/IPID_SOFOSSA0321.pdf';
const SOFASHIELD_TERMS = `${appConfig.webSiteBaseUrl}/sofashield-terms`;
const SOFACHECK_TERMS = 'https://images.sofology.co.uk/image/upload/v1736244861/Bloomreach/Sofology/Sofashield/Sofology_Sofacheck_Document_Jan25_Portrait_FINAL.pdf';

interface OwnProps {
    ref?: React.RefObject<SofashieldPolicy>;
}

interface OwnState {
    isChecked: boolean;
}

export class SofashieldPolicy extends Component<OwnProps, OwnState> implements Validatable, Scrollable {
    state = {
        isChecked: false
    };

    private element = React.createRef<HTMLDivElement>();

    handleChange = (): void => {
        this.setState((state: OwnState) => ({ isChecked: !state.isChecked }));
    };

    render() {
        return (
            <div className='sofashield-policy' ref={this.element}>
                <SofaPanel>
                    <div className='sofashield-policy-wrapper'>
                        {this.renderControlSection()}
                        {this.renderLinks()}
                    </div>
                </SofaPanel>
                {!this.state.isChecked && this.renderError()}
            </div>
        );
    }

    renderError(): JSX.Element {
        return (
            <div className='sofashield-policy-error'>
                <p>Please confirm you have read the details of Sofashield Insurance included in your Sofashield Plus package to continue.</p>
            </div>
        );
    }

    renderControlSection(): JSX.Element {
        return (
            <div className='sofashield-policy-wrapper__control'>
                <div className='sofashield-policy-wrapper__control__checkbox'>
                    <SofaCheckbox
                        label=''
                        inputProps={{ 'aria-labelledby': 'sofashield-policy-label' }}
                        name='sofashield_policy'
                        value={this.state.isChecked}
                        onChange={this.handleChange}
                    />
                </div>
                <div className='sofashield-policy-wrapper__control__text'>
                    <p id='sofashield-policy-label'>I can confirm that I have read and understood the details of <a
                        href={SOFASHIELD_TERMS} rel='noopener noreferrer' target='_blank'>Sofashield Insurance</a> included within my Sofashield Plus package, and I am satisfied that it meets my demands and needs.</p>
                </div>
            </div>
        );
    }

    renderLinks(): JSX.Element {
        return (
            <>
                <div className='sofashield-policy-wrapper__links'>
                    <a href={SOFOLOGY_POLICY_PATH} rel='noopener noreferrer' target='_blank'>Important Policy Information Document<span className='sofashield-policy-wrapper__edge'>*</span></a> <span>|</span>
                    <a href={SOFASHIELD_TERMS} rel='noopener noreferrer' target='_blank'>Terms and Conditions<span className='sofashield-policy-wrapper__edge'>*</span></a> <span>|</span>
                    <a href={SOFACHECK_TERMS} rel='noopener noreferrer' target='_blank'>Sofacheck</a>
                </div>
                <span className='sofashield-policy-wrapper__edge'><p>*Microsoft Edge users: right click the link, click 'Save target as' and then open the document in a different browser.</p></span>
            </>
        );
    }

    validate = (): boolean => {
        return this.state.isChecked;
    };

    scrollTo = () => {
        scrollHelper.scrollTo(this.element);
    };
}